import React, { useCallback, useEffect, useState } from "react";

export default function ({ current, max, subtext }) {
  const [ref, setObjRef] = useState(null);
  const [styles, setStyles] = useState({});
  const setRef = useCallback(setObjRef, []);

  useEffect(() => {
    if (ref !== null) {
      const radius = ref.r.baseVal.value;
      const percent = +current / +max;
      const strokeDasharray = radius * 2 * Math.PI;
      const strokeDashoffset = strokeDasharray - percent * strokeDasharray;

      setStyles({ strokeDasharray, strokeDashoffset });
    }
  }, [current, max, subtext, ref]);

  return (
    <div className="roundprogress">
      <svg fill="#fff">
        <radialGradient id="strokeGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#53ACFF" />
          <stop offset="100%" stopColor="#156DE0" />
        </radialGradient>
        <circle className="roundprogress__stroke" cx="50%" cy="50%" r="35" />
        <circle
          ref={setRef}
          style={styles}
          className="roundprogress__indicator"
          cx="50%"
          cy="50%"
          r="35"
        />
      </svg>
      <div className="roundprogress__text">
        <span className="roundprogress__text_number">{current}</span>
        <span className="roundprogress__text_dt">{subtext}</span>
      </div>
    </div>
  );
}
